import { Reveal, SectionHead } from "./Reveal";
import { ArrowRight } from "lucide-react";
import { waLink } from "@/lib/site";

const INDUSTRIES = [
  "Small Businesses", "Startups", "Restaurants", "Hotels", "Salons", "Clinics",
  "Real Estate", "Used Car Dealers", "Retail Stores", "Professionals", "E-Commerce", "Service Businesses",
];

export const Industries = () => (
  <section data-testid="industries-section" className="bg-ink py-24 md:py-32">
    <div className="mx-auto max-w-7xl px-6 md:px-12">
      <SectionHead eyebrow="Industries" title="We build for your business" />
      <div className="mt-14 grid grid-cols-2 gap-3 md:grid-cols-3 lg:grid-cols-4">
        {INDUSTRIES.map((name, i) => (
          <Reveal key={name} delay={(i % 4) * 0.05}>
            <a
              href={waLink(`Hi Falkeen Technologies, I run a ${name.toLowerCase().replace(/s$/, "")} business and I'm interested in a website.`)}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`industry-${i}`}
              className="group flex items-center justify-between rounded-xl border border-white/5 bg-charcoal px-5 py-5 transition-[border-color,background-color] duration-300 hover:border-accent/40 hover:bg-accent/5"
            >
              <span className="font-display text-xs font-bold uppercase tracking-[0.12em] text-zinc-300 transition-colors duration-300 group-hover:text-white md:text-sm">
                {name}
              </span>
              <ArrowRight className="h-4 w-4 -translate-x-1 text-accent opacity-0 transition-[opacity,transform] duration-300 group-hover:translate-x-0 group-hover:opacity-100" />
            </a>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
